<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import OrderChannelFields from './order/OrderChannelFields.vue'

import { BRAND_APP_ORDER_CHANNELS, type BrandAppShowcaseStore } from '../../lib/brandAppContract'
import useBrandAppConfig from '../../composables/useBrandAppConfig'

defineProps<{
  stores: BrandAppShowcaseStore[]
}>()

const { order, updateOrderChannel } = useBrandAppConfig()
</script>

<template>
  <div class="flex flex-col">
    <PanelGroup v-for="channel in BRAND_APP_ORDER_CHANNELS" :key="channel.id" :title="channel.label">
      <template #action>
        <Switch
          :id="`brandApp.order.${channel.id}.enabled`"
          :aria-label="channel.label"
          :model-value="order.channels[channel.id].enabled"
          @update:model-value="updateOrderChannel(channel.id, 'enabled', $event)"
        />
      </template>

      <OrderChannelFields v-if="order.channels[channel.id].enabled" :channel="channel.id" :stores="stores" />
    </PanelGroup>
  </div>
</template>
